<template>
  <router-view />
</template>
<script>
export default {
  name: 'MobileComponent',
};
</script>
